import { render, staticRenderFns } from "./Visitrecords.vue?vue&type=template&id=ff1def20&scoped=true&"
import script from "./Visitrecords.vue?vue&type=script&lang=js&"
export * from "./Visitrecords.vue?vue&type=script&lang=js&"
import style0 from "./Visitrecords.vue?vue&type=style&index=0&id=ff1def20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1def20",
  null
  
)

export default component.exports